import { render, staticRenderFns } from "./ConabIVA.vue?vue&type=template&id=d29b972c&scoped=true&"
import script from "./ConabIVA.vue?vue&type=script&lang=js&"
export * from "./ConabIVA.vue?vue&type=script&lang=js&"
import style0 from "./ConabIVA.vue?vue&type=style&index=0&id=d29b972c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29b972c",
  null
  
)

export default component.exports